import React from "react";
import classNames from "classnames";

export type ChatSignInScreenProps = {
  firstName: string;
  children?: React.ReactNode;
  imgUrl?: string;
};

export function ChatSignInScreen({ firstName, children, imgUrl }: ChatSignInScreenProps) {
  return (
    <div className='flex flex-col items-center font-sans-serif'>
      {imgUrl && (
        <img
          className={classNames("h-16 w-16")}
          src={imgUrl}
          alt='product'
          style={{
            maxWidth: "240px",
            width: "100%",
            height: "auto",
          }}
        />
      )}
      <div className='text-xl font-semibold mt-5'>{`Digital ${
        firstName ?? ""
      } : “Pick my Brain”`}</div>
      <div className='text-sm mt-5 text-mid-neutral-1'>Once you do, it will appear here.</div>
      {children}
    </div>
  );
}
